import { openDB } from "idb";

const DB_NAME = "cardDB";
const DB_VERSION = 1; // Versionsnummer für DB-Änderungen
const STORE_NAME = "cards";

// Funktion: Datenbank öffnen und `objectStore` erstellen, falls nicht vorhanden
const getDb = async () => {
  return await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    },
  });
};

// Funktion: Karte speichern oder aktualisieren
export const saveCard = async (card) => {
  const db = await getDb();
  await db.put(STORE_NAME, card);
};

// Funktion: Alle Karten abrufen
export const getAllCards = async () => {
  const db = await getDb();
  return await db.getAll(STORE_NAME);
};

// Funktion: Karte löschen
export const deleteCard = async (id) => {
  const db = await getDb();
  await db.delete(STORE_NAME, id);
};
